import React from 'react';

export const HomeIconDesktop = () => (
  <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 25.356V17.856H17.5V25.356H23.75V15.356H27.5L15 4.10596L2.5 15.356H6.25V25.356H12.5Z"
      fill="#F0EAD7"
    />
  </svg>
);

export const HomeIconMobile = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33329 16.6667V11.6667H11.6666V16.6667H15.8333V10H18.3333L9.99996 2.5L1.66663 10H4.16663V16.6667H8.33329Z"
      fill="#F0EAD7"
    />
  </svg>
);
